<template>
  <h3 class="text-3xl font-semibold mb-10">Other Courses</h3>
  <div class="flex flex-col gap-y-4 text-lg">
    <ProOrCon :isPro=false>
      <p>Teach Lambda, API Gateway, DynamoDB, EventBridge, Step Functions as separate services.</p>
    </ProOrCon>
    <ProOrCon :isPro=false>
      <p>Focus on building and deploying.</p>
    </ProOrCon>
    <ProOrCon :isPro=false>
      <p>Give examples that work in demos.</p>
    </ProOrCon>
    <ProOrCon :isPro=false>
      <p>Leave you to adapt patterns alone.</p>
    </ProOrCon>
  </div>
</template>

<script>
import ProOrCon from './ProOrCon.vue'

export default {
  components: {
    ProOrCon
  }
}
</script>
